import { type StateCreator } from 'zustand';

import { type CanvasTokenNode } from './createCanvasTokenNodeSlice';

export type ChatHistoryNodeSlice = {
  inactiveNodes: Record<string, CanvasTokenNode>;
  nodes: Record<string, CanvasTokenNode>;
  setInactiveNodes: (nodes: Record<string, CanvasTokenNode>) => void;
  setNodes: (nodes: Record<string, CanvasTokenNode>) => void;
};

export type CreateChatHistoryNodeSlice = () => StateCreator<ChatHistoryNodeSlice, [], [], ChatHistoryNodeSlice>;

export const createChatHistoryNodeSlice: CreateChatHistoryNodeSlice = () => (set) => ({
  inactiveNodes: {},
  nodes: {},
  setInactiveNodes: (inactiveNodes) => {
    set({ inactiveNodes });
  },
  setNodes: (nodes) => {
    set({ nodes });
  },
});
